import {
    WS_PREPLAY_START_ACTION,
    WS_PREPLAY_OFF_ACTION,
    WS_PREPLAY_UPDATE_ACTION,
} from './preplay';
import {
    getWsInterface,
    WS_CONNECTION_NAME,
    UNNAMED_WS_HANDLER_SCOPE,
} from '../../spa/Utils/Websockets';

export const WS_EVENT_START_ACTION = WS_PREPLAY_START_ACTION;
export const WS_EVENT_OFF_ACTION = WS_PREPLAY_OFF_ACTION;
export const WS_EVENT_UPDATE_ACTION = WS_PREPLAY_UPDATE_ACTION;
export const WS_EVENT_MARKET_RESULT = 'inplay_market_result';
export const WS_EVENT_RESULTS = 'events_results';
export const WS_EVENT_INPLAY_UPDATE_ACTION = 'inplay_update';

const wsInterface = getWsInterface();

/**
 * This file is deprecated. Use mainSocketClass instead
 * @deprecated see AM-2540
 */

/**
 * Sets if the handlers have been set or not
 * @type {Boolean}
 */
let isWsEventHandlersSet = false;

/**
 * A Set holding the list of update event listeners
 * @type {Set}
 */
const wsEventUpdateListeners = new Set();

/**
 * The ws event update handler
 * @param  {Array} args The arguments passed from the websocket
 * @return {void}
 */
export const wsEventUpdateHandler = (...args) => {
    const listeners = Array.from(wsEventUpdateListeners);

    listeners.forEach(listener => listener(...args));
};

/**
 * A helper to set the ws handlers
 * @param {String} [wsHandlerScope=UNNAMED_WS_HANDLER_SCOPE] a unique scope for the handler e.g. "RacingWidget-horse-racing"
 * @return {void}
 */
const setWsHandlers = (wsHandlerScope = UNNAMED_WS_HANDLER_SCOPE) => {
    wsInterface.requestHandler(WS_CONNECTION_NAME).registerHandler(WS_EVENT_START_ACTION, wsEventUpdateHandler, wsHandlerScope);
    wsInterface.requestHandler(WS_CONNECTION_NAME).registerHandler(WS_EVENT_OFF_ACTION, wsEventUpdateHandler, wsHandlerScope);
    wsInterface.requestHandler(WS_CONNECTION_NAME).registerHandler(WS_EVENT_UPDATE_ACTION, wsEventUpdateHandler, wsHandlerScope);
    wsInterface.requestHandler(WS_CONNECTION_NAME).registerHandler(WS_EVENT_INPLAY_UPDATE_ACTION, wsEventUpdateHandler, wsHandlerScope);

    isWsEventHandlersSet = true;
};

/**
 * Starts listening for ws updates
 * @param {Array} subscriptionData array of {event_id: 1, markets: [{id: 1, selections: [3, 4]}]}
 * @param {String} [wsHandlerScope=UNNAMED_WS_HANDLER_SCOPE] a unique scope for the handler e.g. "RacingWidget-horse-racing"
 * @return {void}
 */
export function startListeningForWsEventUpdates(subscriptionData, wsHandlerScope = UNNAMED_WS_HANDLER_SCOPE) {
    wsInterface.requestHandler(WS_CONNECTION_NAME).subscribe(subscriptionData);

    if (!isWsEventHandlersSet) {
        setWsHandlers(wsHandlerScope);
    }
}

/**
 * Stops listening for ws updates
 * @param {Array} unSubscriptionData array of {event_id: 1, markets: [{id: 1, selections: [3, 4]}]}
 * @return {void}
 */
export function stopListeningForWsEventUpdates(unSubscriptionData) {
    wsInterface.requestHandler(WS_CONNECTION_NAME).unsubscribe(unSubscriptionData);
}

/**
 * Handle on ws event update
 * @param  {Function} callback A callback that is called with the started event
 * @return {Function} A callback to unsubscribe from the event
 */
export function onWsEventUpdate(callback) {
    wsEventUpdateListeners.add(callback);

    return function unsubscribe() {
        wsEventUpdateListeners.delete(callback);
    };
}
